import type { RouteRecordRaw } from 'vue-router'

export const devRoutes: RouteRecordRaw[] = [
  {
    path: '/dev',
    children: [
      {
        path: 'ui-kit',
        name: 'DevUIKit',
        component: () => import('./UIKit.vue'),
        meta: {
          title: 'UI Kit',
          requiresAuth: false
        }
      }
    ]
  }
]
